import { Typography } from '@mui/material';
import { RouteInfo } from '../../../../routes';
import { findItemWithParents } from '../helper/findItemWithParents';
import { ReactComponent as ArrowDown } from '../../../../assets/icons/arrowDown.svg';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from '../styles/sx';

interface IMenuAccordion {
  title: string;
  routeInfo: RouteInfo;
  currentActiveKeys: string[];
  layers: number;
  setCurrentActiveKeys: React.Dispatch<React.SetStateAction<string[]>>;
  children: JSX.Element;
}

const MenuAccordion = (props: IMenuAccordion) => {
  const { title, children, routeInfo, currentActiveKeys, layers, setCurrentActiveKeys } = props;

  const onAccordionChange = () => {
    // If the accordion is already expanded, collapse it
    if (currentActiveKeys.includes(routeInfo.key)) {
      setCurrentActiveKeys(currentActiveKeys.filter((key) => key !== routeInfo.key));
      return;
    }
    setCurrentActiveKeys(findItemWithParents(routeInfo.key));
  };

  const isExpanded = currentActiveKeys.includes(routeInfo.key);

  const isFirstLayer = layers === 1;

  return (
    <StyledAccordion disableGutters expanded={isExpanded} onChange={onAccordionChange}>
      <StyledAccordionSummary
        expandIcon={isFirstLayer && <ArrowDown />}
        aria-controls={title}
        isFirstLayer={isFirstLayer}
      >
        <Typography variant={isFirstLayer ? 'h4' : 'button'}>{title}</Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails isFirstLayer={isFirstLayer} layers={layers}>
        {children}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};

export default MenuAccordion;
